/**
 * Попап для просмотра дипломов в полном размере
 */
var DiplomaPopup = {
	init: function() {
		// Клик по миниатюре диплома
		document.querySelectorAll('.psy-profile__education-diploma img').forEach(function(img) {
			img.addEventListener('click', function() {
				DiplomaPopup.open(this.getAttribute('data-full') || this.src);
			});
		});

		// Закрытие по клику на фон
		var popup = document.getElementById('popup-diploma');
		if (popup) {
			popup.addEventListener('click', function(e) {
				if (e.target === popup || e.target.classList.contains('popup__wrapper')) {
					DiplomaPopup.close();
				}
			});
		}

		// Закрытие по Escape
		document.addEventListener('keydown', function(e) {
			if (e.key === 'Escape' && popup && popup.classList.contains('active')) {
				DiplomaPopup.close();
			}
		});
	},

	open: function(src) {
		var popup = document.getElementById('popup-diploma');
		var img = document.getElementById('popup-diploma-img');
		if (!popup || !img) return;

		img.src = src;
		popup.classList.add('active');
		document.body.style.overflow = 'hidden';
	},

	close: function() {
		var popup = document.getElementById('popup-diploma');
		if (popup) {
			popup.classList.remove('active');
		}
		document.body.style.overflow = '';
	}
};

document.addEventListener('DOMContentLoaded', function() {
	DiplomaPopup.init();
});

window.DiplomaPopup = DiplomaPopup;
